const reqObj: Recordable = {};
const reqArr: Array<() => void> = [];
let time = 8000;
let isLoading = false;
// 间隔时间2s
const requestArr = (obj: object, reqFunc: any, cacheTime?: number) => {
  if (cacheTime) {
    time = cacheTime;
  }
  const execPromise = new Promise((resolve, reject) => {
    const execFunc = () => {
      if (isLoading) {
        return;
      }
      const init = () => {
        isLoading = false;
        const func = reqArr.shift();
        if (func) {
          func();
        }
      };
      const key = JSON.stringify(obj);
      if (
        reqObj[key]?.result &&
        new Date().getTime() - reqObj[key].reqTime < time
      ) {
        resolve(reqObj[key].result);
        init();
        return;
      }
      isLoading = true;
      reqFunc(obj)
        .then((res: any) => {
          // 请求过长，key数据可能被delete了
          if (!reqObj[key]) {
            reqObj[key] = {
              result: null,
              reqTime: new Date().getTime(),
            };
          }
          reqObj[key].result = res;
          resolve(res);
        })
        .catch((err: any) => {
          reject(err);
        })
        .finally(() => {
          init();
        });
    };
    reqArr.push(execFunc);
    execFunc();

    // 确保没有缓存数据残留
    setTimeout(() => {
      Object.keys(reqObj).forEach((key) => {
        if (new Date().getTime() - reqObj[key].reqTime > time) {
          delete reqObj[key];
        }
      });
    }, time + 2000);
  });
  return execPromise;
};
interface CacheItem {
  result: any;
  expire: number;
  pending?: Promise<any>;
}
const cacheMap = new Map<string, CacheItem>();
const CACHE_TIME = 2000;
let interval: number | undefined; // 清理缓存定时器
export async function requestCacheFn<T>(
  obj: Recordable,
  reqFunc: (params: any) => Promise<T>,
  cacheTime?: number
): Promise<T> {
  const key = JSON.stringify(obj);
  if (cacheMap.has(key)) {
    const item = cacheMap.get(key)!;
    // 未超过缓存时间
    if (Date.now() < item.expire) return item.result;

    // 复用请求
    if (item.pending) return item.pending;
  }
  // 发送请求
  const pendingRequest = reqFunc(obj);
  const cacheItem: CacheItem = {
    result: null,
    expire: 0,
    pending: pendingRequest,
  };
  // 设置缓存项
  cacheMap.set(key, cacheItem);
  startCleanTimer();
  try {
    const result = await pendingRequest;
    cacheItem.result = result;
    cacheItem.expire = Date.now() + (cacheTime || CACHE_TIME);
    return cacheItem.result;
  } catch (error) {
    // 请求失败删除缓存项目
    cacheMap.delete(key);
    return Promise.reject(error);
  } finally {
    cacheItem.pending = undefined;
  }
}
function startCleanTimer(delay: number = 5000) {
  if (!interval) {
    interval = setInterval(() => {
      cacheMap.forEach((item, key) => {
        if (Date.now() > item.expire && !item.pending) {
          cacheMap.delete(key);
        }
      });
      if (cacheMap.size === 0) {
        clearInterval(interval);
        interval = undefined;
      }
    }, delay);
  }
}

export default requestArr;
